import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { signoutUser } from '../../actions/userActions'
import focusable from '../../components/Focusable/Focusable'
import StdButton from '../../components/StdButton/StdButton'
import tts from '../../lib/TTS'
import { triggerSentryError } from '../../../../shared/helpers'
import googleAnalytics4 from '../../lib/googleAnalytics'
import { withRouter } from '../../../../shared/components/WithRouter/WithRouter'

class SignoutScreen extends React.Component {
  constructor(props) {
    super(props)

    this.buttonRefs = []
    this.focusedIndex = 0
    this.state = {
      id: 'SignoutScreen',
      error: false,
    }
  }

  componentDidMount() {
    // report sign out attempt
    /* window.ga('send', {
      hitType: 'event',
      eventCategory: 'Settings Dialog',
      eventAction: 'Deactivate Channel',
    }) */

    tts.addTextToRead(
      `Currently signed in as ${
        this.props.user.email
      }. In order to switch your account, you must sign out of the PBS app and sign in again. Focused on ${
        this.buttonRefs[this.focusedIndex].props.label
      }`
    )

    googleAnalytics4.sendPageViewEvent('Sign-out')
  }

  onKeyEvent(key) {
    let handled = false
    const focusedComponent = window.focusedComponent
    const componentType = focusedComponent.componentType

    if ('BACK' === key) {
      this.props.router.navigate(-1)
    }

    if (componentType) {
      switch (componentType) {
        case 'signoutButton':
          if ('UP' === key) {
            this.focusedIndex = 0
            this.buttonRefs[this.focusedIndex]?.setFocus()
            tts.stopRead()
            tts.addTextToRead(
              `Focused on ${this.buttonRefs[this.focusedIndex].props.label}`
            )
            handled = true
          }

          if ('ENTER' === key) {
            this.signOut()
            handled = true
          }
          break

        case 'cancelButton':
          if ('DOWN' === key) {
            this.focusedIndex = 1
            this.buttonRefs[this.focusedIndex]?.setFocus()
            tts.stopRead()
            tts.addTextToRead(
              `Focused on ${this.buttonRefs[this.focusedIndex].props.label}`
            )
            handled = true
          }

          if ('ENTER' === key) {
            this.props.router.navigate(-1)
            handled = true
          }
          break

        default:
          break
      }
    }

    return handled
  }

  signOut() {
    signoutUser()
      .then(() => {
        this.props.dispatch({ type: 'SIGN_OUT' })
        this.props.router.navigate('/activate')
      })
      .catch((error) => {
        triggerSentryError('signOut', 'SignoutScreen.js', {
          errorMessage: error.message ?? 'Undefined error message (default)',
          errorLocation: 'SingoutScreen - signOut',
        })
      })
  }

  setRefs(component, i) {
    if (null !== component) {
      this.buttonRefs[i] = component

      if (i === 0) {
        this.buttonRefs[i]?.setFocus()
      }
    }
  }

  render() {
    const { error } = this.state
    const { user } = this.props

    if (error) {
      tts.addTextToRead(
        'Unable to deactivate at this time. Please try again later.'
      )
    }
    return (
      <div className="signout-screen-container">
        <div className="text-container">
          <h1 className="title">Currently signed in as {user.email}</h1>
          <p className="text">
            In order to switch your account, you must sign out of the PBS app
            and sign in again.
          </p>
        </div>

        <div className="signout-button-container">
          <StdButton
            label="Cancel Button"
            parent={this}
            componentType="cancelButton"
            ref={(component) => {
              this.setRefs(component, 0)
            }}
          >
            Cancel
          </StdButton>

          <StdButton
            label="Sign Out Button"
            parent={this}
            componentType="signoutButton"
            ref={(component) => {
              this.setRefs(component, 1)
            }}
          >
            {error ? 'Try Again' : 'Sign Out'}
          </StdButton>
        </div>

        <p className={`error-message ${error ? 'errored' : ''}`}>
          Unable to deactivate at this time. Please try again later.
        </p>
      </div>
    )
  }
}

SignoutScreen.propTypes = {
  dispatch: PropTypes.func,
  router: PropTypes.shape({
    navigate: PropTypes.func,
  }),
  user: PropTypes.shape({
    email: PropTypes.string,
  }),
}

const mapStateToProps = (state) => {
  return {
    UID: state.device.UID,
    deviceId: state.device.deviceId,
    user: state.user,
  }
}

export default connect(
  mapStateToProps,
  null,
  null
)(withRouter(focusable(SignoutScreen)))
